import { formatDialect, KeywordCase } from 'sql-formatter';
import { getSqlFormatConfigByDbType } from '../utils/database/sql';
import { DB_TYPE } from '../define/common.define';
import { useMessage } from '../inject/useMessage';
import { useInternational } from '../locale';

export type ParamType = { regex: string };

export interface FormatSqlResult {
  text: string;
  success: boolean;
}

export const useFormatSqlText = () => {
  const { t } = useInternational();
  const { showWarningMsg } = useMessage();

  const formatSqlText = (
    sqlText: string | null,
    dbTypeStr: string,
    option?: { keywordCase?: KeywordCase; showMsg?: boolean; customParamTypes?: ParamType[] },
  ): FormatSqlResult => {
    const showMsg = option?.showMsg ?? true;

    if (!sqlText) {
      return { text: '', success: false };
    }

    const dbType = DB_TYPE[dbTypeStr.toUpperCase()] ?? null;

    const { dialect, paramTypes } = getSqlFormatConfigByDbType(dbType);
    const customParamTypes = [...(paramTypes?.custom ?? []), ...(option?.customParamTypes ?? [])];
    const mergedParamTypes =
      paramTypes || customParamTypes.length
        ? {
            ...paramTypes,
            custom: customParamTypes,
          }
        : undefined;

    try {
      const text = formatDialect(`${sqlText}`, {
        dialect,
        tabWidth: 2,
        keywordCase: option?.keywordCase ?? 'upper',
        linesBetweenQueries: 2,
        paramTypes: mergedParamTypes,
      });
      return { text, success: true };
    } catch (e) {
      if (showMsg) {
        showWarningMsg({ msgStr: t('MESSAGE.SQL_FORMAT_ERROR') });
      }
      console.error(e);
      return { text: sqlText, success: false };
    }
  };

  return {
    formatSqlText,
  };
};
